module.exports = __webpack_public_path__ + "src/components/DocumentList/pdf_image.png?dfb7987e";


//////////////////
// WEBPACK FOOTER
// ./src/components/DocumentList/pdf_image.png
// module id = 3352
// module chunks = 8